import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { Router } from '@angular/router';
import { AjaxService } from '../../../services/ajax.service';
import { Utility } from '../../../shared/utility/utility';
import { EmitterService } from '../../../services/emitter.service';
import { UserDetailsService } from '../../../services/user-details.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";


@Component({
  selector: 'app-preference-center',
  templateUrl: './preference-center.component.html',
  styleUrls: ['./preference-center.component.scss']
})
export class PreferenceCenterComponent implements OnInit, OnDestroy {
  message:boolean=false;
  initalPref;
  serverError;
  langCode;
  @Output() triggerAccountMenu = new EventEmitter<{}>();
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private ajaxService:AjaxService,
    private utils:Utility,
    private emitterService: EmitterService,
    private router:Router,
    private userDetailsService: UserDetailsService
  ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
      this.langCode = langCode;

    })
  }

  ngOnInit() {
      this.showPreferences("");
  }
  @Output() close = new EventEmitter();
  gotoMyAccount() {
    if (document.body.clientWidth <= 992) {
      this.close.emit();
    }else{
      this.router.navigate([this.langCode + '/myaccount'])
    }
    
  }
  updatePreference(selectedPref1,selectedPref2){

    $("input[type=checkbox]").attr('disabled', true);
    let data = {
      "emailSubscribed":($('#emailOnly').is(":checked") ?true:false),
      "mobileSubscribed":($('#smsOnly').is(":checked") > 0?true:false)
    }


    this.ajaxService.updateSubscriptionPreferenes(data)
    .then(prefResposne=>{
        if(prefResposne["status"] === "SUCCESS"){
          this.showPreferences("SUCCESS");//,selectedPref1);
          this.message= true;
          setTimeout(() => {
            this.message = false;
            // If Mobile close the section
            if (document.body.clientWidth <= 992) {
              this.close.emit();
            }
          }, 5000);
        }else{
          this.showPreferences("FAILIURE");//,selectedPref1);
            this.emitterService.broadcastserverError(" ","/myaccount")
        }
    },SystemError => {
      this.showPreferences("FAILIURE");//,selectedPref1);
        this.emitterService.broadcastserverError(" ","/myaccount")

    })
    .catch(error => {});
  }
  showPreferences(status){
    if(status == 'SUCCESS'){
      this.userDetailsService.userPreferenceData = undefined;
    }
    if(!this.userDetailsService?.userPreferenceData){
      this.ajaxService.getSubscriptionPreferenes()
      .then((prefResposne)=>{
        this.updatePreferenceInfo(prefResposne,status);
        this.userDetailsService.userPreferenceData = prefResposne;
      })
      .catch(error=>{
        this.userDetailsService.userPreferenceData = undefined
      });
    }else{
      this.updatePreferenceInfo(this.userDetailsService.userPreferenceData,status);
    }
    

  }
  updatePreferenceInfo(prefResposne,status){
    if(prefResposne){
      $('#smsOnly').attr('checked',prefResposne["mobileSubscribed"]);
      $('#emailOnly').attr('checked',prefResposne["emailSubscribed"]);
      $("input[type=checkbox]").attr('disabled', false);
      $("input[type=checkbox]:checked").attr('disabled', false);
    }

    let userDetails = this.userDetailsService.getUserProfileDetails();
    if(prefResposne["mobileSubscribed"] || prefResposne["emailSubscribed"] && userDetails) {
      this.utils.deleteNotifyCookie('subscribe-preference' + userDetails.nickname);
    }
    this.emitterService.broadCastnotificationEvent("");
    status !== "" && status !== "SUCCESS"? this.utils.showError("errorMessagePrefCentre"):"";
  }
    goBack(){
      this.triggerAccountMenu.emit(true);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
